import { render, staticRenderFns } from "./ServiceVisitCommentsList.vue?vue&type=template&id=22269874&scoped=true&"
import script from "./ServiceVisitCommentsList.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitCommentsList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitCommentsList.vue?vue&type=style&index=0&id=22269874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22269874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VIcon,VSkeletonLoader,VTooltip})
